import { Component, Input } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'wl-spinner',
  standalone: true,
  imports: [ProgressSpinner],
  template: `
    <p-progress-spinner
      [strokeWidth]="strokeWidth"
      fill="transparent"
      [animationDuration]="speed"
      [style]="{ width: size, height: size }"
    />
  `,
  styleUrl: './spinner.component.scss',
  host: {
    '[style]': '{ width: size, height: size }',
  },
})
export class SpinnerComponent {
  @Input() strokeWidth = '8';
  @Input() speed = '0.8s';
  @Input() size = '24px';
}
